import SSOQuickDeposit from './SSOQuickDeposit';

export default SSOQuickDeposit;
